import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { PaymentScenarionConditionKindEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.condition.kind.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link PaymentScenarionConditionKindEnum} enumeration values */
export const PaymentScenarionConditionKindEnumI18n: EnumI18nInterface<PaymentScenarionConditionKindEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [PaymentScenarionConditionKindEnum.AMOUNT]: 'Сумма',
    [PaymentScenarionConditionKindEnum.BUDGET_EXHAUSTED]: 'Сумма бюджета исчерпана',
    [PaymentScenarionConditionKindEnum.COMPANY]: 'Плательщик',
    [PaymentScenarionConditionKindEnum.COST_CENTER]: 'Центр затрат',
    [PaymentScenarionConditionKindEnum.DEAL]: 'Сделка',
    [PaymentScenarionConditionKindEnum.DIRECTION]: 'Бюджетная статья',
    [PaymentScenarionConditionKindEnum.EXCEEDING_PLAN]: 'Превышение плана',
    [PaymentScenarionConditionKindEnum.FILIAL]: 'Филиал',
    [PaymentScenarionConditionKindEnum.UNIT]: 'Бюджетная единица',
  },
  [I18nLocalesEnum.EN_US]: {
    [PaymentScenarionConditionKindEnum.AMOUNT]: 'Amount',
    [PaymentScenarionConditionKindEnum.BUDGET_EXHAUSTED]: 'Budget amount is exhausted',
    [PaymentScenarionConditionKindEnum.COMPANY]: 'Company',
    [PaymentScenarionConditionKindEnum.COST_CENTER]: 'Cost center',
    [PaymentScenarionConditionKindEnum.DEAL]: 'Deal',
    [PaymentScenarionConditionKindEnum.DIRECTION]: 'Direction',
    [PaymentScenarionConditionKindEnum.EXCEEDING_PLAN]: 'Exceding plan',
    [PaymentScenarionConditionKindEnum.FILIAL]: 'Filial',
    [PaymentScenarionConditionKindEnum.UNIT]: 'Unit',
  },
};
